var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LineChart',{ref:"chart",attrs:{"chartData":_vm.chartData,"options":_vm.chartOptions,"height":100}})
}
var staticRenderFns = []

export { render, staticRenderFns }